import { Button } from '@mui/material'
import pkg from '../../../../../package.json'
import image from '../../../../assets/icons/warning-icon.svg'
import { featureFlags } from '../../../../configs/feature-flags'
import useAppStore from '../../../../stores/app'
import Timer from './Timer'
import './versionWarningNotification.scss'

const VersionWarningNotification = () => {
  const socketVersion = useAppStore(state => state.socket_version)
  const updateSocketVersion = useAppStore(state => state.updateSocketVersion)
  const currentVersion = pkg.version
  const reload = () => {
    updateSocketVersion()
    window.location.reload()
  }

  if (!socketVersion || socketVersion === currentVersion || location.pathname === '/login' || !featureFlags.versionWarningNotification) {
    return null
  }
  return (
    <div className="warning-notification-container">
      <div className="warning-content">
        <img src={image} alt="warning" />
        <p className="title">Warning! Need Reload Page!</p>
        <div>
          <p className="subtitle">A new version of the dashboard {socketVersion} has been released. Your current local version is outdated.</p>
          <p className="subtitle">Please reload the page or the page will automatically reload in <Timer /> minutes.</p>
        </div>
      </div>
      <Button
        variant="contained"
        className="warning-notification-button"
        onClick={reload}>
                Reload the Page
      </Button>
    </div>
  )
}

export default VersionWarningNotification
